import { round as trueRound } from './internal/round';

export function round(value: number, decimals: number): number {
  return trueRound(value, decimals) as number;
}
